var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex align-center justify-center pie-chart__container"},[_c('vue-chart',{staticClass:"pie-chart",attrs:{"option":_vm.graphData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }